// extracted by mini-css-extract-plugin
export var orderSummary = "_lp-0";
export var showMoreLessButton = "_lp-1";